<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Участие в других компаниях ({{items.length > 100 ? 'более 100' : items.length}})
        <template v-for="item in topItems">
          <div>
            <div v-html="renderReference(item)">
            </div>
            <v-flex pl-2>
              <div>ИНН <b><span v-html="renderInnHtml(item.inn)"></span></b> - 
                <span v-html="renderStatus(item.status)"></span>
              </div>
              <span v-html="renderFirstActivityHtml(item.activities)"></span>
              <template v-for="holder in [getFirst(item.holders)]">
                <b>Участие {{formatPercent(holder)}} {{formatShare(holder)}}</b>
                <span v-html="renderDateSince(holder)"></span>
              </template>
            </v-flex>
          </div>
        </template>      
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <v-flex v-if="items.length===0">
      Данные не найдены.
      </v-flex>
      <div v-show = "items.length > 0 && items.length > 100">
        <b>ВАЖНО!</b> Показываются только 100 дочерних компаний, отфильтрованных по величине доли. Для показа всех дочерних компаний направьте нам письмо на электронную почту {{getOpenSettings.supportMail}}<br/><br/>
      </div>                
      <template v-for="item in lastItems">
        <div>
          <div v-html="renderReference(item)">
          </div>
          <v-flex pl-2>
            <div>ИНН <b><span v-html="renderInnHtml(item.inn)"></span></b> - 
              <span v-html="renderStatus(item.status)"></span>
            </div>
            <span v-html="renderFirstActivityHtml(item.activities)"></span>
              <template v-for="holder in [getFirst(item.holders)]">
                <b>Участие {{formatPercent(holder)}} {{formatShare(holder)}}</b>
                <span v-html="renderDateSince(holder)"></span>
              </template>
          </v-flex>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-children-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      },
      topCount: {
        type: Number,
        default: 2
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderDateSince: 'renderDateSince',
        renderStatus: 'renderStatus',
        renderFirstActivityHtml: 'renderFirstActivityHtml',
        renderShare: 'renderShare',
        getOpenSettings: 'getOpenSettings'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + ' руб.' : ''
      },
      formatShare (holder) {
        var share = formats.getValue(holder, ['shares', 0, 'share'])
        return share !== null ? '(' + this.formatCurrency(share) + ')' : ''
      },
      formatPercent (holder) {
        var share = formats.getValue(holder, ['shares', 0])
        return this.renderShare(share)
      },
      getFirst (items) {
        return items && items.length > 0 && items[0] || null
      },
      sortItems (a, b) {
        const getRank = (kind) => ['GOOD', 'WARN', 'BAD', 'OLD'].indexOf(kind)

        var result = 0
        if (!result) {
          result = getRank(a.status.kind) - getRank(b.status.kind)
        }
        let aholder = this.getFirst(a.holders)
        let bholder = this.getFirst(b.holders)
        if (!result && !(bholder && aholder)) {
          result = (bholder != null) - (aholder != null)
        }
        if (!result && (bholder && aholder)) {
          var valB = formats.getValue(bholder, ['shares', 0, 'part', 'numerator']) / formats.getValue(bholder, ['shares', 0, 'part', 'denominator'])
          var valA = formats.getValue(aholder, ['shares', 0, 'part', 'numerator']) / formats.getValue(aholder, ['shares', 0, 'part', 'denominator'])
          result = valB - valA
        }
        if (!result && (bholder && aholder)) {
          result = (formats.getValue(bholder, ['shares', 0, 'share']) - formats.getValue(aholder, ['shares', 0, 'share']))
        }
        return result
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о дочерних компаниях из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/children',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.items = data
            this.items.sort((a, b) => this.sortItems(a, b))
            this.isLoading = false
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// ChildrenPanel.vue?8afd7bd0